export const translations = {
  es: {
    // Layout
    dashboard: 'Dashboard',
    myRewards: 'Mis Rewards',
    challenges: 'Challenges',
    history: 'Historial',
    level: 'Instancias',
    days: 'días',
    logout: 'Cerrar Sesión',
    poweredBy: 'Powered by PEpL',
    
    // Dashboard
    hello: '¡Hola, {name}!',
    streak: 'días seguidos',
    instances: 'Instancias de Mejora',
    sessionsMonth: 'Sesiones Enero',
    visits: 'Visitas',
    calories: 'Calorías',
    redeemed: 'Canjeados',
    active: 'Activos',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mes',
    vsPrev: 'vs prev',
    rewardsReady: '🎁 Recompensas Listas para Ti',
    required: 'req.',
    redeemNow: 'Canjear ahora',
    recentSessions: '📊 Tus Últimas Sesiones',
    series: 'series',
    
    // Dashboard Cards/Mock Data
    cardio: 'Cardio',
    strength: 'Fuerza',
    wellness: 'Wellness',
    sessionUnlocked: '🎁 Sesión Descontracturante desbloqueada',
    upgradeAvailable: '🎁 Upgrade Recovery disponible',
    sessionCompleted: '🧘 Sesión completada',
    
    // Rewards
    descontracturante: 'Sesión Descontracturante',
    hydration: 'Hidratación Wellness',
    reasonCardio: '5.2km cardio hoy',
    reasonStreak: 'Racha 8 días',

    // Login
    loginTitle: 'Portal de Miembros',
    emailLabel: 'Email',
    passwordLabel: 'Contraseña',
    emailPlaceholder: 'tu@email.com',
    passwordPlaceholder: '••••••••',
    loginButton: 'Acceder a Mi Cuenta',
    loginButtonLoading: 'Iniciando sesión...',
    welcomeReward: '🎁 ¡Bienvenido al programa de recompensas!',
    accumulatePoints: 'Acumula puntos con cada entrenamiento y canjéalos por experiencias de bienestar',

    // Challenges
    challengesTitle: '🏆 Wellness Challenges',
    challengesSubtitle: 'Caldea Club × PEpL — Desafíos de bienestar',
    activeChallenges: 'Challenges Activos',
    completed: 'Completados',
    achievements: 'Logros',
    ranking: 'Ranking',
    tabMyChallenges: 'Mis Challenges',
    tabAvailable: 'Disponibles',
    tabAchievements: 'Logros',
    weekly: 'Semanal',
    monthly: 'Mensual',
    timeLeft: 'días restantes',
    progress: 'Progreso',
    participants: 'participantes',
    join: 'Unirme',

    // Rewards Page
    rewardsTitle: 'Mis Recompensas',
    rewardsSubtitle: 'Caldea Club × PEpL Recovery Rewards',
    improvementLevel: 'Nivel de Mejora',
    activeTriggers: '⚡ Tus Triggers Activos',
    ready: '¡Listo!',
    tabAvailableRewards: 'Recompensas Disponibles',
    tabHistory: 'Historial de Canjes',
    valleyHours: 'Horario valle:',
    improvementCost: 'Instancias',

    // Transactions
    transactionsTitle: 'Transacciones',
    order: 'Orden',
    service: 'Servicio',
    status: 'Estado',
    amount: 'Monto',
    date: 'Fecha',
    noTransactions: 'No hay transacciones registradas'
  },
  en: {
    // Layout
    dashboard: 'Dashboard',
    myRewards: 'My Rewards',
    challenges: 'Challenges',
    history: 'History',
    level: 'Instances',
    days: 'days',
    logout: 'Log Out',
    poweredBy: 'Powered by PEpL',

    // Dashboard
    hello: 'Hello, {name}!',
    streak: 'day streak',
    instances: 'Improvement Instances',
    sessionsMonth: 'January Sessions',
    visits: 'Visits',
    calories: 'Calories',
    redeemed: 'Redeemed',
    active: 'Active',
    thisWeek: 'This week',
    thisMonth: 'This month',
    vsPrev: 'vs prev',
    rewardsReady: '🎁 Rewards Ready for You',
    required: 'req.',
    redeemNow: 'Redeem Now',
    recentSessions: '📊 Your Recent Sessions',
    series: 'sets',
    
    // Dashboard Cards/Mock Data
    cardio: 'Cardio',
    strength: 'Strength',
    wellness: 'Wellness',
    sessionUnlocked: '🎁 Decontracting Session unlocked',
    upgradeAvailable: '🎁 Recovery Upgrade available',
    sessionCompleted: '🧘 Session completed',

    // Rewards
    descontracturante: 'Decontracting Session',
    hydration: 'Wellness Hydration',
    reasonCardio: '5.2km cardio today',
    reasonStreak: '8 day streak',

    // Login
    loginTitle: 'Member Portal',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    emailPlaceholder: 'you@email.com',
    passwordPlaceholder: '••••••••',
    loginButton: 'Access My Account',
    loginButtonLoading: 'Logging in...',
    welcomeReward: '🎁 Welcome to the rewards program!',
    accumulatePoints: 'Accumulate points with every workout and redeem them for wellness experiences',

    // Challenges
    challengesTitle: '🏆 Wellness Challenges',
    challengesSubtitle: 'Caldea Club × PEpL — Wellness Challenges',
    activeChallenges: 'Active Challenges',
    completed: 'Completed',
    achievements: 'Achievements',
    ranking: 'Ranking',
    tabMyChallenges: 'My Challenges',
    tabAvailable: 'Available',
    tabAchievements: 'Achievements',
    weekly: 'Weekly',
    monthly: 'Monthly',
    timeLeft: 'days left',
    progress: 'Progress',
    participants: 'participants',
    join: 'Join',

    // Rewards Page
    rewardsTitle: 'My Rewards',
    rewardsSubtitle: 'Caldea Club × PEpL Recovery Rewards',
    improvementLevel: 'Improvement Level',
    activeTriggers: '⚡ Your Active Triggers',
    ready: 'Ready!',
    tabAvailableRewards: 'Available Rewards',
    tabHistory: 'Redemption History',
    valleyHours: 'Off-peak hours:',
    improvementCost: 'Instances',

    // Transactions
    transactionsTitle: 'Transactions',
    order: 'Order',
    service: 'Service',
    status: 'Status',
    amount: 'Amount',
    date: 'Date',
    noTransactions: 'No transactions recorded'
  }
};
